import "@qb-assets-js/js-extensions"
import "@qb-assets-js/dom-extensions"
import {cT} from '@qb-assets-js/content-tag'
cT.register()
import "@qb-assets-js/qb-elements"